export { default as NResult, resultProps } from './src/Result';
